"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const FileVideoUpload_1 = __importDefault(require("modules/file/components/player/FileVideoUpload"));
const constants_1 = require("modules/file/constants");
const DeviceTab = ({ onClose, replaceMediaId }) => {
    const handleFileChange = (sendMultiples, items, actions) => {
        const options = {};
        if (replaceMediaId) {
            actions === null || actions === void 0 ? void 0 : actions.delete(replaceMediaId);
            options.forceReplace = true;
        }
        sendMultiples(items, options);
        onClose();
    };
    return ((0, jsx_runtime_1.jsx)(FileVideoUpload_1.default, { reusable: true, multiple: false, entityType: constants_1.ENTITY_TYPE.PAGE_MEDIA, fileLibraryProvider: null, beforeSend: handleFileChange }));
};
exports.default = (0, flowRight_1.default)((0, mobx_react_1.inject)((stores) => ({
    replaceMediaId: stores.PlayerBackofficeStore.replaceMediaId
})))(DeviceTab);
